import styled from 'styled-components';
import { ContainerRef } from '../styles';

export const Container = styled(ContainerRef)`

p,svg,h2,h3,strong{
    color: #333;
}

`;